export const HOME_PAGE_ADMIN = "/admin/homepage";
export const HOME_PAGE_AFFILIATE = "/affiliate/homepage";
export const HOME_PAGE_EDITOR = "/editor/advertisers";
